import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Card, CardContent } from "../../../components/ui/card";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { Badge } from "../../../components/ui/badge";
import { Plus, Trash2, UserPlus } from "lucide-react";
import { MKT, getAdminAuth } from "./AdminEmailMarketing";

export default function ListsTab({ onChanged, onPickContacts }) {
  const [lists, setLists] = useState([]);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const fetchLists = async () => {
    try {
      const res = await axios.get(`${MKT}/lists`, getAdminAuth());
      setLists(res.data.lists);
    } catch (e) { toast.error("Failed to load lists"); }
  };
  useEffect(() => { fetchLists(); }, []);

  const createList = async () => {
    if (!name.trim()) return;
    try {
      await axios.post(`${MKT}/lists`, { name, description }, getAdminAuth());
      toast.success("List created");
      setName(""); setDescription("");
      fetchLists(); onChanged?.();
    } catch (e) { toast.error("Failed to create list"); }
  };

  const deleteList = async (l) => {
    if (!window.confirm(`Delete list "${l.name}"? Contacts will NOT be deleted.`)) return;
    try {
      await axios.delete(`${MKT}/lists/${l.list_id}`, getAdminAuth());
      toast.success("List deleted (contacts kept)");
      fetchLists(); onChanged?.();
    } catch (e) { toast.error("Failed"); }
  };

  return (
    <div className="space-y-4 mt-4" data-testid="marketing-lists-tab">
      <div className="flex flex-wrap gap-2">
        <Input placeholder="List name (e.g. Garage Door Companies)" value={name} onChange={(e) => setName(e.target.value)} className="max-w-xs" data-testid="new-list-name" />
        <Input placeholder="Description (optional)" value={description} onChange={(e) => setDescription(e.target.value)} className="max-w-sm" />
        <Button onClick={createList} data-testid="create-list-btn"><Plus className="w-4 h-4 mr-1" />Create List</Button>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {lists.map(l => (
          <Card key={l.list_id} className="border-border" data-testid={`list-card-${l.name}`}>
            <CardContent className="p-4 space-y-3">
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-foreground truncate">{l.name}</p>
                  {l.description && <p className="text-xs text-muted-foreground truncate">{l.description}</p>}
                  <Badge className="mt-2 bg-blue-500/15 text-blue-400 text-[10px]">{l.contact_count} contacts</Badge>
                </div>
                <Button variant="ghost" size="sm" onClick={() => deleteList(l)} data-testid={`delete-list-${l.name}`}>
                  <Trash2 className="w-3.5 h-3.5 text-red-400" />
                </Button>
              </div>
              <Button variant="outline" size="sm" className="w-full" onClick={() => onPickContacts?.(l)} data-testid={`add-contacts-to-${l.name}`}>
                <UserPlus className="w-3.5 h-3.5 mr-1.5" />Add contacts
              </Button>
            </CardContent>
          </Card>
        ))}
        {lists.length === 0 && <p className="text-sm text-muted-foreground col-span-3">No lists yet. Create lists like "Garage Door Companies", "California Leads", "Canada Leads"…</p>}
      </div>
    </div>
  );
}
